@import '../../../constants/spacing.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.check {
  border-radius: 50%;
  color: var(--green-700);
  width: 16px;
  height: 16px;
  padding: @space-0;
}

.dashed-ellipse {
  width: 16px;
  height: 16px;
}
